import { withInstall } from '@ll-plus/utils'

import Tree from './src/tree.vue'

export const LlTree = withInstall(Tree)
export default LlTree
export * from './src/tree'

declare module 'vue' {
  export interface GlobalComponents {
    LlTree: typeof Tree
  }
}
